import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

export interface DashboardStats {
  objets: {
    total: number;
    parEtat: Record<string, number>;
    parCategorie: Record<string, number>;
    sansPhoto: number;
    besoinAchat: number;
  };
  zones: {
    total: number;
    avecTheme: number;
    sansTheme: number;
  };
  boxes: {
    total: number;
    horsDomicile: number;
    auDomicile: number;
  };
}

export const useDashboardStats = () => {
  return useQuery<DashboardStats>({
    queryKey: ['stats', 'dashboard'],
    queryFn: async () => {
      console.log('🔍 Fetching dashboard stats from API...');
      const response = await apiClient.get('/stats/dashboard');
      console.log('📊 Dashboard stats received:', response.data);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
